import { BillingPaymentOld } from "../BillingPaymentOld";
import { InsuranceWithBillingRegions } from "./InsuranceWithBillingRegions";
import { useInsuranceWithBilling } from "./useInsuranceWithBilling";
import { Insurance } from "../Insurance";

type InsuranceWithBillingProps = {
  shouldShowBilling: boolean;
};

export const InsuranceWithBilling = ({
  shouldShowBilling = true,
}: InsuranceWithBillingProps) => {
  const { billing } = useInsuranceWithBilling();

  return (
    <InsuranceWithBillingRegions
      billingPayment={
        shouldShowBilling ? <BillingPaymentOld billing={billing} /> : null
      }
      insurance={<Insurance />}
    />
  );
};
